import axios from 'axios';
import { cmsUrl } from '../../variables';

export default {
    loadAllQuestions(context) {
        context.commit('loadAllQuestions');
        context.commit('loadAllQuestionCategories');
        axios
            .get(cmsUrl + '/questions')
            .then(data => context.commit('loadAllQuestionsSuccess', data.data))
            .catch(err => context.commit('loadAllQuestionsError', err))
        axios
            .get(cmsUrl + '/question_categories')
            .then(data => context.commit('loadAllQuestionCategoriesSuccess', data.data))
            .catch(err => context.commit('loadAllQuestionsError', err))
    },
    loadAllQuestionCategories(context) {
        
    },
    searchQuestions(context, payload) {
        context.commit('searchQuestions');
        axios
            .get(cmsUrl + '/question_search?query=' + payload)
            .then(data => context.commit('searchQuestionsSuccess', { query: payload, data: data.data }))
            .catch(err => context.commit('searchQuestionsError', err))
    },
    searchQuestionsReset(context) {
        context.commit('searchReset');
    },
    updateQuestionCategoryFilter(context, payload) {
        context.commit('updateQuestionCategoryFilter', payload);
    },
    selectQuestion(context, payload) {
        context.commit('selectQuestion', payload);
        if (!context.state.questions.hasLoaded) {
            context.dispatch('loadAllQuestions');
        }
    },

};